import type { ScanBarState } from '../shell/scanFocus'
import { StationShell } from '../ui/StationShell'
import type { CameraState } from '../ui/ScanBar'

/**
 * Scan the bin once, then scan books into it (SHV-01). The bin tile is the
 * scannable-object tile from the component inventory; it does not compete with
 * the scan bar for the halo, because the scan bar already says what to scan.
 */
export interface ShelvingProps {
  scan: ScanBarState
  camera?: CameraState
  bin: { id: string; label: string } | null
  shelved: Array<{ unitId: string; title: string }>
  pendingDrafts?: number
  online?: boolean
}

export function Shelving({ scan, camera, bin, shelved, pendingDrafts = 0, online = true }: ShelvingProps) {
  return (
    <StationShell
      title="Shelve"
      progress={`${shelved.length} shelved`}
      scan={scan}
      camera={camera}
      pendingDrafts={pendingDrafts}
      online={online}
    >
      <section className={`tile tile-bin${bin ? ' tile-open' : ' tile-waiting'}`}>
        <span className="tile-glyph" data-glyph="bin" aria-hidden="true" />
        <span className="t-title">{bin ? bin.label : 'No bin open'}</span>
        <span className="count-tick t-display">{shelved.length}</span>
      </section>

      <ul className="row-list">
        {shelved.map((s) => (
          <li key={s.unitId} className="row accept-settled">
            <span className="t-scan">{s.unitId}</span>
            <span>{s.title}</span>
          </li>
        ))}
      </ul>
    </StationShell>
  )
}
